import { memo } from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'

import s from './Transition.module.less'

interface IProps {
  children: JSX.Element
  in?: boolean
  key?: string | number
}

export const TransitionFade = memo<IProps>(function TransitionFade({ children, ...rest }) {
  return (
    <CSSTransition
      {...rest}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 10, exit: 200 }}
      classNames={{
        appear: s['fade-enter'],
        appearActive: s['fade-enter-active'],
        enter: s['fade-enter'],
        enterActive: s['fade-enter-active'],
        exit: s['fade-exit'],
        exitActive: s['fade-exit-active']
      }}
    >
      {children}
    </CSSTransition>
  )
})
